import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ApiService, URLS } from 'app/services/api.service';
import { UserStorageService } from 'app/services/user-storage.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private apiservice: ApiService, private userService: UserStorageService) {
    //console.log('login component constructor');
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      //console.log("Can Active", next, state);
      //this.sessionTime();
      if (state.url == '/register' || state.url == '/forgotpassword'){
        return true;
      } else if (state.url == '/lockscreen'){
        if (this.userService.isActive() && this.userService.isBlock()){
          return true;
        } else {
          this.redrectMapa();
          return false;
        }
      } else if (state.url == '/login'){
        if (this.userService.isBlock() && this.userService.isActive()){
          this.redrectLookScreen();
          return false;
        } else if (!this.userService.isActive()){
          return true;
        } else {
          this.redrectMapa();
          return false;
        }
      } else if (this.userService.isActive()){
         if (this.userService.isBlock()){
          this.redrectLookScreen();
          return false;
        } else {
          this.userService.updateTime();
          return true;
        }
      } else { 
        this.redrectLogin();
        return false;
      }
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
      //console.log("Can Active Child", childRoute, state);
     // this.sessionTime();
      if (state.url == '/register' || state.url == '/forgotpassword'){
        return true;
      } else if (state.url == '/lockscreen'){
        if (this.userService.isActive() && this.userService.isBlock()){
          return true;
        } else {
          this.redrectMapa();
          return false;
        }
      } else if (state.url == '/login'){
        if (this.userService.isBlock() && this.userService.isActive()){
          this.redrectLookScreen();
          return false;
        } else if (!this.userService.isActive()){
          return true;
        } else {
          this.redrectMapa();
          return false;
        }
      } else if (this.userService.isActive()){
        if (this.userService.isBlock()){
          this.redrectLookScreen();
          return false;
        } else {
          this.userService.updateTime();
          return true;
        }
      } else { 
        this.redrectLogin();
        return false;
      }
  }

  // sessionTime(){
  //   var vm = this;
  //   var user = vm.userService.getUser();
  //   if (user != null) {
  //       this.apiservice.get(URLS.GET_SESSION_TIME, '', this.apiservice.getHostRio())
  //       .subscribe(
  //           function(data){
  //               if (!data){
  //                 vm.userService.setInactive();
  //               }
  //           },
  //           function(error){
  //               console.log(error);
  //           });
  //   }
  // }

  redrectLogin(){
    this.router.navigate(['/login']);
  }

  redrectLookScreen(){
    this.router.navigate(['/lockscreen']);
  }

  redrectMapa(){
    this.router.navigate(['/mapa']);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/auth.guard.ts